import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { useSeo } from '../hooks/useSeo';
const blocks = [{
  title: 'Unternehmen:',
  lines: ['Hot Sales Girls – Mermaid Beauty Aesthetics FZCO']
}, {
  title: 'Vertreten durch die Geschäftsführerin:',
  lines: ['Tina Hermann']
}, {
  title: 'Adresse:',
  lines: ['Dubai Silicon Oasis', 'DDP, Building A1', 'Dubai, Vereinigte Arabische Emirate']
}, {
  title: 'Lizenznummer:',
  lines: ['23153', 'Dubai Silicon Oasis Authority (DSOA)']
}, {
  title: 'E-Mail:',
  lines: ['info@hotsalesgirls.com']
}, {
  title: 'Haftungsausschluss:',
  lines: ['Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Trotz sorgfältiger Prüfung übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.']
}];
export function Impressum() {
  useSeo({
    title: 'Impressum | Hot Sales Girls Academy',
    description: 'Impressum und Anbieterkennzeichnung der Hot Sales Girls – Mermaid Beauty Aesthetics FZCO, Dubai Silicon Oasis.',
    path: '/impressum',
    noIndex: true
  });
  return <div className="min-h-screen w-full" data-id="element-553" data-mp="2a0ai7qers6id">
      <div className="pink-panel relative" data-id="element-554" data-mp="36smcm93stzja">
        <div className="relative z-10" data-id="element-555" data-mp="36q9yy852qbc1">
          <Navbar data-id="element-556" data-mp="31srr6l2sm25m" />

          <main className="relative w-full bg-cream px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-12" data-id="element-557" data-mp="31ucgnwa92uwm">
            <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-558" data-mp="2xqmzvszthhm5" />
            <span aria-hidden="true" className="gold-glitter-extra" data-id="element-559" data-mp="2st4nfsmlck9e" />
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="mx-auto max-w-3xl text-center" data-id="element-560" data-mp="2suxsj3hk2wfa">
              <h1 className="inline-block rounded-full border border-gold/60 px-5 py-2 text-xs font-semibold uppercase tracking-[0.25em] text-neutral-700" data-id="element-561" data-mp="1iu3lzrdtdhn1">
                Impressum
              </h1>

              <div className="mt-6 space-y-8" data-id="element-562" data-mp="19uotyni00z0f">
                {blocks.map(block => <section key={block.title} data-id="element-563" data-mp="1duzagu3f37tj">
                    <h2 className="font-heading text-lg font-bold text-neutral-900 sm:text-xl" data-id="element-564" data-mp="1dtp99w19pjio">
                      {block.title}
                    </h2>
                    {block.lines.map(line => <p key={line} className="mt-2 text-sm leading-relaxed text-neutral-700 sm:text-base" data-id="element-565" data-mp="14w59ysmytxap">
                        {line}
                      </p>)}
                  </section>)}
              </div>
            </motion.div>
          </main>

          <Footer data-id="element-566" data-mp="m3b02d478vdc" />
        </div>
      </div>
      <CookieBanner data-id="element-567" data-mp="m6fgc8uxvhkd" />
    </div>;
}